import { useParams } from 'react-router-dom'
import { useContext, useState, useEffect, useRef } from 'react'
import { APIContext } from 'context/APIContext'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'
import ProgramLevelDropdown from 'components/Program/ProgramLevelDropdown'
import MacroVolumeFocusTypeDropdown from 'components/Program/MacroVolumeConfig/MacroVolumeFocusTypeDropdown'
import MesoVolumeConfigDisplay from 'components/Program/MesoVolumeConfig/MesoVolumeConfigDisplay'

export default function MesoVolumeView() {

    const { urlMesoVolumeId } = useParams()

    const hasFetchedRef = useRef(false)

    const { GetMesoVolume } = useContext(APIContext)

    const [programLevelHashMap, setProgramLevelHashMap] = useState(null)
    const [macroVolumeFocusTypeHashMap, setMacroVolumeFocusTypeHashMap] = useState(null)
    const [microVolumeStimulusTypeHashMap, setMicroVolumeStimulusTypeHashMap] = useState(null)
    const [mesoVolume, setMesoVolume] = useState(null)
    
    const LoadMesoVolumeData = async () => {
        const result = await GetMesoVolume(urlMesoVolumeId)
        setProgramLevelHashMap(result.programLevelHashMap)
        setMacroVolumeFocusTypeHashMap(result.macroVolumeFocusTypeHashMap)
        setMicroVolumeStimulusTypeHashMap(result.microVolumeStimulusTypeHashMap)
        setMesoVolume(result.mesoVolume)
    }

    const HandleMesoVolumeConfigDraftChange = (key, value) => {
        /*
        switch (key) {
            case 'macroVolumeFocusTypeId':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    macroVolumeFocusTypeId: value,
                }))
                break
            case 'mesoVolumeLevelTypeId':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    mesoVolumeLevelTypeId: value,
                }))
                break
            case 'level':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    level: parseInt(value),
                }))
                break
            case 'name':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    name: value,
                }))
                break
            case 'description':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    description: value,
                }))
                break
            case 'add-new-micro-volume-config-to-start':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    microVolumes: [__GetNewMicroVolumeConfig(), ...previous.microVolumes],
                }))
                break
            case 'add-new-micro-volume-config-to-end':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    microVolumes: [...previous.microVolumes, __GetNewMicroVolumeConfig()],
                }))
                break
            case 'delete-micro-volume-config':
                setMesoVolumeConfigDraft((previous) => ({
                    ...previous,
                    microVolumes: previous.microVolumes.filter((_, index) => index !== value),
                }))
                break
            case 'duplicate-micro-volume-config':
                setMesoVolumeConfigDraft((previous) => {
                    const microVolumes = [...previous.microVolumes]
                    microVolumes.splice(value + 1, 0, {
                        ...structuredClone(previous.microVolumes[value]),
                        _animationUUID: crypto.randomUUID(),
                    })
                    return { ...previous, microVolumes }
                })
                break
            default:
                console.error(key + ' is not a valid key')
                break
        }
        */
    }

    useEffect(() => {
        if (hasFetchedRef.current)return
        hasFetchedRef.current = true
        LoadMesoVolumeData()
    }, [])

    if (
        programLevelHashMap === null
        || macroVolumeFocusTypeHashMap === null
        || mesoVolume === null 
    ) {
        return (
            <ScreenFrame>
                <div className="w-full h-40 bg-gray-200 rounded-xl animate-pulse" />
                <div className="w-full h-40 bg-gray-200 rounded-xl animate-pulse" />
                <div className="w-full h-40 bg-gray-200 rounded-xl animate-pulse" />
            </ScreenFrame>
        )
    }

    return (
        <ScreenFrame>
            <ContentFrame className='p-4 space-y-4'>
                <div className='space-y-2 w-full'>
                    <p className='w-full text-left'>Name</p>

                    <input
                        type="text"
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter name here"
                        value={mesoVolume.name}
                        onChange={(event) => HandleMesoVolumeConfigDraftChange('name', event.target.value)}
                    />
                </div>

                <div className='space-y-2 w-full'>
                    <p className='w-full text-left'>Description</p>

                    <textarea
                        className="w-full h-28 p-2 border border-gray-300 rounded-md"
                        placeholder="Enter description here"
                        value={mesoVolume.description}
                        onChange={(event) => HandleMesoVolumeConfigDraftChange('description', event.target.value)}
                    />
                </div>

                <div className='space-y-2 w-full'>
                    <p className='w-full text-left'>Level</p>

                    <div className='flex items-center gap-x-2'>
                        <div className='flex-1'>
                            <ProgramLevelDropdown
                                allowAll={false}
                                programLevelHashMap={programLevelHashMap}
                                selectedProgramLevel={mesoVolume.programLevelId}
                                setSelectedProgramLevel={(value) => HandleMesoVolumeConfigDraftChange('programLevelId', value)}
                            />
                        </div>
                       
                        <p>-</p>

                        <input
                            type="number"
                            className="w-40 p-2 border border-gray-300 rounded-md"
                            min={1}
                            placeholder="Enter level here"
                            value={mesoVolume.level}
                            onChange={(event) => HandleMesoVolumeConfigDraftChange('level', event.target.value)}
                        />
                    </div>
                </div>

                <div className='space-y-2 w-full'>
                    <p className='w-full text-left'>Focus</p>

                    <MacroVolumeFocusTypeDropdown
                        allowAll={false}
                        macroVolumeFocusTypeHashMap={macroVolumeFocusTypeHashMap}
                        selectedMacroVolumeFocusTypeId={mesoVolume.macroVolumeFocusTypeId}
                        setSelectedMacroVolumeFocusTypeId={(value) => HandleMesoVolumeConfigDraftChange('macroVolumeFocusTypeId', value)}
                    />
                </div>
            </ContentFrame>

            <MesoVolumeConfigDisplay
                mode='edit'
                parameterMacroVolumeFocusTypeHashMap={macroVolumeFocusTypeHashMap}
                parameterMicroVolumeStimulusTypeHashMap={microVolumeStimulusTypeHashMap}
                mesoVolumeConfig={mesoVolume}
                HandleMesoVolumeConfigDraftChange={HandleMesoVolumeConfigDraftChange}
            />

            {/* 
            <BrandColorButton
                text="Save Changes"
                className='shadow-md'
                isLoading={false}
            /> 
            */}
        </ScreenFrame>
    )
}
